import { SorterResult } from 'antd/lib/table/interface';
import { IFBAccount } from 'services/rtk/fbmanager/types/account';
import { IAd } from 'services/rtk/fbmanager/types/ad';
import { IAdset } from 'services/rtk/fbmanager/types/adset';
import { ICab } from 'services/rtk/fbmanager/types/cab';
import { ICampaign } from 'services/rtk/fbmanager/types/campaign';
import { IFBUser } from 'services/rtk/fbmanager/types/user';

import { FBManagerActionTypes, TFBManagerActions } from './actions';
import { IFBmanagerTableName } from './table-settings/reducer';

interface IFBManagerState {
  selectedUsersIds: number[];
  selectedUsers: IFBUser[];
  selectedAccountsIds: number[];
  selectedAccounts: IFBAccount[];
  selectedCabsIds: number[];
  selectedCabs: ICab[];
  selectedCampaignsIds: number[];
  selectedCampaigns: ICampaign[];
  selectedAdsetsIds: number[];
  selectedAdsets: IAdset[];
  selectedAdsIds: number[];
  selectedAds: IAd[];
  canResetFilters: boolean;
  sort:
    | SorterResult<IFBUser>
    | SorterResult<IFBAccount>
    | SorterResult<IAd>
    | SorterResult<IAdset>
    | SorterResult<ICab>
    | SorterResult<ICampaign>;

  withSpent: boolean;
  duplicateCounter: Nullable<number>;
  currentMenuPosition: IFBmanagerTableName;
  searchUsers: string;
  searchAccounts: string;
  searchCabs: string;
  searchCampaigns: string;
  searchAdsets: string;
  searchAds: string;
  usersPage: number;
  accountsPage: number;
  cabsPage: number;
  campaignsPage: number;
  adsetsPage: number;
  adsPage: number;
}

const initialState: IFBManagerState = {
  selectedUsersIds: [],
  selectedUsers: [],
  selectedAccountsIds: [],
  selectedCabsIds: [],
  selectedCabs: [],
  selectedCampaignsIds: [],
  selectedCampaigns: [],
  selectedAdsetsIds: [],
  selectedAdsets: [],
  selectedAdsIds: [],
  selectedAds: [],
  selectedAccounts: [],
  canResetFilters: false,
  sort: {},
  withSpent: false,
  duplicateCounter: 1,
  currentMenuPosition: 'accounts',
  searchUsers: '',
  searchAccounts: '',
  searchCabs: '',
  searchCampaigns: '',
  searchAdsets: '',
  searchAds: '',
  usersPage: 1,
  accountsPage: 1,
  cabsPage: 1,
  campaignsPage: 1,
  adsetsPage: 1,
  adsPage: 1,
};

export const fbManagerReducer = (state = initialState, action: TFBManagerActions): IFBManagerState => {
  switch (action.type) {
    case FBManagerActionTypes.SET_CURRENT_MENU_POSITION:
      return {
        ...state,
        currentMenuPosition: action.payload,
        searchUsers: '',
        searchAccounts: '',
        searchCabs: '',
        searchCampaigns: '',
        searchAdsets: '',
        searchAds: '',
        usersPage: 1,
        accountsPage: 1,
        cabsPage: 1,
        campaignsPage: 1,
        adsetsPage: 1,
        adsPage: 1,
      };
    case FBManagerActionTypes.SELECT_USERS_ROWS:
      return {
        ...state,
        selectedUsersIds: [...state.selectedUsersIds, ...action.payload],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UNSELECT_USERS_ROWS:
      return {
        ...state,
        selectedUsersIds: state.selectedUsersIds.filter((el) => !action.payload.includes(el)),
        canResetFilters: true,
      };
    case FBManagerActionTypes.CLEAR_SELECTED_USERS:
      return { ...state, selectedUsersIds: [], canResetFilters: true };
    case FBManagerActionTypes.SET_SELECTED_USERS:
      return { ...state, selectedUsers: [...state.selectedUsers, ...action.payload], canResetFilters: true };
    case FBManagerActionTypes.UNSET_SELECTED_USERS:
      const usersIds = action.payload.map((user) => user.id);
      return {
        ...state,
        selectedUsers: [...state.selectedUsers.filter((user) => !usersIds.includes(user.id))],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UPDATE_SELECTED_USERS:
      const updatedUsers = state.selectedUsers.map((el) => {
        if (action.payload) {
          for (let i = 0; i < action.payload.length; i++) {
            if (el.id === action.payload[i].id) {
              return { ...action.payload[i] };
            }
          }
        }
        return el;
      });
      return {
        ...state,
        selectedUsers: [...updatedUsers],
        selectedUsersIds:
          updatedUsers.length > 0 ? [...updatedUsers.map((el) => el.id)] : [...state.selectedUsersIds],
        canResetFilters: true,
      };
    //////////////
    case FBManagerActionTypes.SELECT_ACCOUNTS_ROWS_IDS:
      let newArr = [...new Set([...state.selectedAccountsIds, ...action.payload])];
      return { ...state, selectedAccountsIds: [...newArr], canResetFilters: true };
    case FBManagerActionTypes.UNSELECT_ACCOUNTS_ROWS_IDS:
      return {
        ...state,
        selectedAccountsIds: state.selectedAccountsIds.filter((el) => !action.payload.includes(el)),
        canResetFilters: true,
      };
    case FBManagerActionTypes.CLEAR_SELECTED_ACCOUNTS_ROWS_IDS:
      return { ...state, selectedAccountsIds: [], selectedAccounts: [], canResetFilters: true };
    case FBManagerActionTypes.SET_SELECTED_ACCOUNTS:
      return {
        ...state,
        selectedAccounts: [...state.selectedAccounts, ...action.payload],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UNSET_SELECTED_ACCOUNTS:
      const accountsIds = action.payload.map((account) => account.id);
      return {
        ...state,
        selectedAccounts: [...state.selectedAccounts.filter((account) => !accountsIds.includes(account.id))],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UPDATE_SELECTED_ACCOUNTS:
      const updatedAccounts = state.selectedAccounts.map((el) => {
        if (action.payload) {
          for (let i = 0; i < action.payload.length; i++) {
            if (el.id === action.payload[i].id) {
              // @ts-expect-error
              return { id: el.id, ...action.payload[i] };
            }
          }
        }
        return el;
      });
      return {
        ...state,
        selectedAccounts: [...updatedAccounts],
        selectedAccountsIds:
          updatedAccounts.length > 0
            ? [...updatedAccounts.map((el) => el.id)]
            : [...state.selectedAccountsIds],
        canResetFilters: true,
      };
    case FBManagerActionTypes.SELECT_CABS_ROWS_IDS:
      return {
        ...state,
        selectedCabsIds: [...state.selectedCabsIds, ...action.payload],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UNSELECT_CABS_ROWS_IDS:
      return {
        ...state,
        selectedCabsIds: state.selectedCabsIds.filter((el) => !action.payload.includes(el)),
        canResetFilters: true,
      };
    case FBManagerActionTypes.CLEAR_SELECTED_CABS_ROWS_IDS:
      return { ...state, selectedCabsIds: [], canResetFilters: true };
    case FBManagerActionTypes.SET_SELECTED_CABS:
      return { ...state, selectedCabs: [...state.selectedCabs, ...action.payload], canResetFilters: true };
    case FBManagerActionTypes.UNSET_SELECTED_CABS:
      const payloadCabIds = action.payload.map((cab) => cab.id);
      return {
        ...state,
        selectedCabs: [...state.selectedCabs.filter((cab) => !payloadCabIds.includes(cab.id))],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UPDATE_SELECTED_CABS:
      const updatedCabs = state.selectedCabs.map((el) => {
        if (action.payload) {
          for (let i = 0; i < action.payload.length; i++) {
            if (el.id === action.payload[i].id) {
              //@ts-expect-error
              return { id: el.id, ...action.payload[i] };
            }
          }
        }
        return el;
      });
      return {
        ...state,
        selectedCabs: [...updatedCabs],
        selectedCabsIds:
          updatedCabs.length > 0 ? [...updatedCabs.map((el) => el.id)] : [...state.selectedCabsIds],
        canResetFilters: true,
      };
    case FBManagerActionTypes.SELECT_CAMPAIGNS_ROWS:
      return {
        ...state,
        selectedCampaignsIds: [...state.selectedCampaignsIds, ...action.payload],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UNSELECT_CAMPAIGNS_ROWS:
      return {
        ...state,
        selectedCampaignsIds: state.selectedCampaignsIds.filter((el) => !action.payload.includes(el)),
        canResetFilters: true,
      };
    case FBManagerActionTypes.CLEAR_SELECTED_CAMPAIGNS:
      return { ...state, selectedCampaignsIds: [], canResetFilters: true };
    case FBManagerActionTypes.SET_SELECTED_CAMPAIGNS:
      return {
        ...state,
        selectedCampaigns: [...state.selectedCampaigns, ...action.payload],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UNSET_SELECTED_CAMPAIGNS:
      const campaignsIds = action.payload.map((campaign) => campaign.id);
      return {
        ...state,
        selectedCampaigns: [
          ...state.selectedCampaigns.filter((campaign) => !campaignsIds.includes(campaign.id)),
        ],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UPDATE_SELECTED_CAMPAIGNS:
      const updatedCampaigns = state.selectedCampaigns.map((el) => {
        if (action.payload) {
          for (let i = 0; i < action.payload.length; i++) {
            if (el.id === action.payload[i].id) {
              return { ...action.payload[i] };
            }
          }
        }
        return el;
      });
      return {
        ...state,
        selectedCampaigns: [...updatedCampaigns],
        selectedCampaignsIds:
          updatedCampaigns.length > 0
            ? [...updatedCampaigns.map((el) => el.id)]
            : [...state.selectedCampaignsIds],
        canResetFilters: true,
      };
    case FBManagerActionTypes.SELECT_ADSETS_ROWS:
      return {
        ...state,
        selectedAdsetsIds: [...state.selectedAdsetsIds, ...action.payload],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UNSELECT_ADSETS_ROWS:
      return {
        ...state,
        selectedAdsetsIds: state.selectedAdsetsIds.filter((el) => !action.payload.includes(el)),
        canResetFilters: true,
      };
    case FBManagerActionTypes.CLEAR_SELECTED_ADSETS:
      return { ...state, selectedAdsetsIds: [], canResetFilters: true };
    case FBManagerActionTypes.SET_SELECTED_ADSETS:
      return {
        ...state,
        selectedAdsets: [...state.selectedAdsets, ...action.payload],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UNSET_SELECTED_ADSETS:
      const adsetsIds = action.payload.map((adset) => adset.id);
      return {
        ...state,
        selectedAdsets: [...state.selectedAdsets.filter((adset) => !adsetsIds.includes(adset.id))],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UPDATE_SELECTED_ADSETS:
      const updatedAdsets = state.selectedAdsets.map((el) => {
        if (action.payload) {
          for (let i = 0; i < action.payload.length; i++) {
            if (el.id === action.payload[i].id) {
              return { ...action.payload[i] };
            }
          }
        }
        return el;
      });
      return {
        ...state,
        selectedAdsets: [...updatedAdsets],
        selectedAdsetsIds:
          updatedAdsets.length > 0 ? [...updatedAdsets.map((el) => el.id)] : [...state.selectedAdsetsIds],
        canResetFilters: true,
      };
    case FBManagerActionTypes.SELECT_ADS_ROWS:
      return {
        ...state,
        selectedAdsIds: [...state.selectedAdsIds, ...action.payload],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UNSELECT_ADS_ROWS:
      return {
        ...state,
        selectedAdsIds: state.selectedAdsIds.filter((el) => !action.payload.includes(el)),
        canResetFilters: true,
      };
    case FBManagerActionTypes.CLEAR_SELECTED_ADS:
      return { ...state, selectedAdsIds: [], canResetFilters: true };
    case FBManagerActionTypes.SET_SELECTED_ADS:
      return { ...state, selectedAds: [...state.selectedAds, ...action.payload], canResetFilters: true };
    case FBManagerActionTypes.UNSET_SELECTED_ADS:
      const adsIds = action.payload.map((ad) => ad.id);
      return {
        ...state,
        selectedAds: [...state.selectedAds.filter((ad) => !adsIds.includes(ad.id))],
        canResetFilters: true,
      };
    case FBManagerActionTypes.UPDATE_SELECTED_ADS:
      const updatedAds = state.selectedAds.map((el) => {
        if (action.payload) {
          for (let i = 0; i < action.payload.length; i++) {
            if (el.id === action.payload[i].id) {
              return { ...action.payload[i] };
            }
          }
        }
        return el;
      });
      return {
        ...state,
        selectedAds: [...updatedAds],
        selectedAdsIds:
          updatedAds.length > 0 ? [...updatedAds.map((el) => el.id)] : [...state.selectedAdsIds],
        canResetFilters: true,
      };
    case FBManagerActionTypes.REFRESH_TABLES:
      return {
        ...state,
        selectedUsersIds: [],
        selectedAccountsIds: [],
        selectedCabsIds: [],
        selectedCabs: [],
        selectedCampaignsIds: [],
        selectedAdsetsIds: [],
        selectedAdsIds: [],
        selectedAccounts: [],
        canResetFilters: false,
        sort: {},
        withSpent: false,
      };
    case FBManagerActionTypes.SET_SORT:
      return { ...state, sort: action.payload };
    case FBManagerActionTypes.SET_WITH_SPENT:
      return { ...state, withSpent: action.payload };
    case FBManagerActionTypes.SET_DUPLICATE_COUNTER:
      return { ...state, duplicateCounter: action.payload };
    case FBManagerActionTypes.SET_SEARCH_USERS:
      return { ...state, searchUsers: action.payload, usersPage: 1 };
    case FBManagerActionTypes.SET_SEARCH_ACCOUNTS:
      return { ...state, searchAccounts: action.payload, accountsPage: 1 };
    case FBManagerActionTypes.SET_SEARCH_CABS:
      return { ...state, searchCabs: action.payload, cabsPage: 1 };
    case FBManagerActionTypes.SET_SEARCH_CAMPAIGNS:
      return { ...state, searchCampaigns: action.payload, campaignsPage: 1 };
    case FBManagerActionTypes.SET_SEARCH_ADSETS:
      return { ...state, searchAdsets: action.payload, adsetsPage: 1 };
    case FBManagerActionTypes.SET_SEARCH_ADS:
      return { ...state, searchAds: action.payload, adsPage: 1 };
    case FBManagerActionTypes.SET_USERS_PAGE:
      return { ...state, usersPage: action.payload };
    case FBManagerActionTypes.SET_ACCOUNTS_PAGE:
      return { ...state, accountsPage: action.payload };
    case FBManagerActionTypes.SET_CABS_PAGE:
      return { ...state, cabsPage: action.payload };
    case FBManagerActionTypes.SET_CAMPAIGNS_PAGE:
      return { ...state, campaignsPage: action.payload };
    case FBManagerActionTypes.SET_ADSETS_PAGE:
      return { ...state, adsetsPage: action.payload };
    case FBManagerActionTypes.SET_ADS_PAGE:
      return { ...state, adsPage: action.payload };

    default:
      return state;
  }
};
